//src/layouts/auth/LoginForm.js
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../../services/authService";
import Cookies from "js-cookie";

export default function LoginForm() {
  // Hook điều hướng
  const navigate = useNavigate();

  // 📌 State lưu dữ liệu form đăng nhập
  const [formData, setFormData] = useState({ email: "", password: "" });

  // 📌 State lưu thông báo lỗi
  const [error, setError] = useState("");

  // 📌 State điều khiển hiển thị modal chọn trang (khi là admin hoặc staff)
  const [showRoleModal, setShowRoleModal] = useState(false);

  // 📌 State lưu tạm quyền (role) của user sau khi đăng nhập thành công
  const [tempRole, setTempRole] = useState("");

  const [isSubmitting, setIsSubmitting] = useState(false);


  // 📌 Xử lý khi thay đổi input (email hoặc password)
  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  // 📌 Xử lý khi submit form đăng nhập
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsSubmitting(true);

    try {
      const result = await loginUser(formData);

      // Lưu cookie
      Cookies.set("user", JSON.stringify(result.user), { expires: 7 });
      Cookies.set("accessToken", result.accessToken, { expires: 7 });

      const role = result.user.role;

      if (role === "admin" || role === "staff") {
        setTempRole(role); // lưu tạm role để điều hướng sau
        setShowRoleModal(true);
      } else {
        navigate("/");
        window.location.reload();
      }

    } catch (err) {
      console.error("Login error:", err);
      setError(err.response?.data?.message || "Đăng nhập thất bại");
    }
    finally {
      setIsSubmitting(false);
    }
  };

  // 📌 Điều hướng sang trang admin (và reload lại để load dữ liệu admin)
  const goToAdmin = () => {
    setShowRoleModal(false);
    navigate("/admin");
    window.location.reload();
  };

  // 📌 Điều hướng sang trang chủ (và reload lại để load dữ liệu user)
  const goToHome = () => {
    setShowRoleModal(false);
    navigate("/");
    window.location.reload();
  };

  return (
    <>
      {/* Form */}
      <form onSubmit={handleSubmit} className="space-y-4 max-w-md mx-auto">
        {error && <div className="text-red-500">{error}</div>}
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
            Email
          </label>
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
            className="w-full p-2 border rounded"
          />
        </div>
        {/* Password */}
        <div>
          <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
            Mật khẩu
          </label>
          <input
            type="password"
            name="password"
            placeholder="Mật khẩu"
            value={formData.password}
            onChange={handleChange}
            required
            className="w-full p-2 border rounded"
          />
        </div>
        <button
          type="submit"
          disabled={isSubmitting}
          className={`w-full py-2 rounded text-white 
    ${isSubmitting ? "bg-blue-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"}`}
        >
          {isSubmitting ? "Đang xử lý..." : "Đăng nhập"}
        </button>
        {/* Link quên mật khẩu */}
        <div className="text-right">
          <button
            type="button"
            onClick={() => navigate("/forgot-password")}
            className="text-sm text-blue-600 hover:underline"
          >
            Quên mật khẩu?
          </button>
        </div>
      </form>

      {/* Modal chọn trang */}
      {showRoleModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-80">
            <h2 className="text-lg font-semibold mb-4">
              Xin chào{" "}
              {tempRole === "admin"
                ? "Quản trị viên"
                : tempRole === "staff"
                  ? "Nhân viên"
                  : ""}
              !
            </h2>
            <p className="mb-4">Bạn muốn truy cập trang nào?</p>
            <div className="flex justify-end space-x-3">
              <button
                onClick={goToHome}
                className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300"
              >
                Trang chính
              </button>
              <button
                onClick={goToAdmin}
                className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700"
              >
                Quản trị
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
